import $ from "jquery";
import "slick-carousel";
import Glide from "@glidejs/glide";
import Splide from "@splidejs/splide";

/* eslint-disable */
export default function sliders() {
  // Slider progress bars
  var time = 2;
  var time1 = 2;
  var $bar,
    $courses,
    $slick,
    $testimonials,
    $awards,
    $articles,
    $photos,
    $faqs,
    isPause,
    tick,
    percentTime,
    $bar1,
    isPause1,
    tick1,
    percentTime1,

    $bar10,
    isPause10,
    tick10,
    percentTime10,

    $bar2,
    isPause2,
    tick2,
    percentTime2,
    $bar3,
    isPause3,
    tick3,
    percentTime3,
    $bar4,
    isPause4,
    tick4,
    percentTime4,
    $testimonialshalf,
    $posts,
    $timelines,
    $activities,
    $accomodation,
    $reviews,
    $instagram,
    $ns_collective_ltr,
    $ns_collective_rtl,
    $reviews_mobile,
    $video_slider,
    $series_slider,
    $series_slider_lg,
    $course_spec_slider,
    $bar5,
    $courses_info_boxes_slider,
    $bar6,
    isPause6,
    tick6,
    percentTime6;

  var phototoggleval = 0,
    photoSlideWidth;

  $slick = $(".slider");
  $courses = $(".courses-slider");
  $testimonials = $(".testimonials-slider");
  $testimonialshalf = $(".testimonials-half-slider");
  $awards = $(".awards-slider");
  $articles = $(".articles-slider");
  $photos = $(".photos-slider");
  $faqs = $(".faq-slider");
  $posts = $(".post-slider");
  $timelines = $(".timeline-slider");
  $activities = $(".activities-slider");
  $accomodation = $(".accomodation-slider");
  $reviews = $(".reviews-slider");
  $reviews_mobile = $(".reviews-slider--mobile");
  $instagram = $(".instagram-slider");
  $ns_collective_ltr = $(".the_nonstop_collective_ltr-slider");
  $ns_collective_rtl = $(".the_nonstop_collective_rtl-slider");
  $series_slider = $(".series-slider");
  $series_slider_lg = $(".series-slider-lg");
  $course_spec_slider = $(".course-spec-slider");
  $video_slider = $(".video_slider");
  $courses_info_boxes_slider = $(".courses-info-boxes-slider");

  $video_slider.slick({
    arrows: false,
    speed: 1200,
    adaptiveHeight: false,
    dots: false,
    autoplay: false,
    fade: false,
    slidesToShow: 1,
    infinite: true,
    draggable: false,
  });

  $course_spec_slider.slick({
    arrows: false,
    speed: 1200,
    dots: false,
    autoplay: false,
    fade: false,
    slidesToShow: 2,
    infinite: false,
    draggable: true,
    touchThreshold: 100,

    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $series_slider.slick({
    arrows: false,
    speed: 1200,
    dots: false,
    autoplay: true,
    fade: false,
    slidesToShow: 7,
    infinite: true,
    draggable: true,
    touchThreshold: 100,
    swipeToSlide: true,
    touchThreshold: 100,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });

  $series_slider.removeClass("hidden");

  $series_slider_lg.slick({
    arrows: false,
    speed: 1200,
    dots: false,
    autoplay: true,
    fade: false,
    slidesToShow: 4,
    infinite: true,
    draggable: true,
    touchThreshold: 100,
    adaptiveHeight: true,
    swipeToSlide: true,
    touchThreshold: 100,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });

  //images are initially hidden for smoother transition
  $series_slider_lg.removeClass("hidden");

  $courses.slick({
    arrows: false,
    speed: 600,
    adaptiveHeight: false,
    dots: false,
    fade: false,
    slidesToShow: 4,
    draggable: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  });

  $articles.slick({
    arrows: false,
    speed: 600,
    adaptiveHeight: false,
    dots: false,
    fade: false,
    slidesToShow: 4,
    draggable: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $photos.slick({
    arrows: false,
    speed: 600,
    adaptiveHeight: false,
    dots: false,
    fade: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    draggable: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $testimonials.slick({
    arrows: false,
    speed: 1200,
    adaptiveHeight: true,
    dots: true,
    autoplay: true,
    fade: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          adaptiveHeight: true,
        },
      },
    ],
  });

  $testimonialshalf.slick({
    arrows: false,
    speed: 1200,
    adaptiveHeight: false,
    dots: false,
    autoplay: true,
    fade: false,
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $awards.slick({
    arrows: false,
    speed: 1200,
    adaptiveHeight: true,
    dots: false,
    autoplay: true,
    fade: false,
    slidesToShow: 2,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  // $faqs.slick({
  //   arrows: false,
  //   speed: 1200,
  //   adaptiveHeight: false,
  //   dots: false,
  //   autoplay: false,
  //   fade: false,
  //   slidesToShow: 2,
  //   variableWidth: true,
  //   infinite: false,
  //   responsive: [
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 1,
  //       },
  //     },
  //   ],
  // });

  if ($(".faq-glider").length) {
    // var type = "slider";
    // var draggable = false;
    // if ($(".faq-glider").find(".glide__slides").children().length > 2) {
    //   type = "carousel";
    //   draggable = true;
    // }

    new Glide(".glide", {
      type: "carousel",
      perView: 2,
      peek: {
        before: 0,
        after: 200,
      },
      // dragThreshold: draggable,
      // swipeThreshold: draggable,
      gap: 50,
      breakpoints: {
        1535: {
          perView: 2,
          peek: {
            before: 0,
            after: 100,
          },
          gap: 32,
        },
        1024: {
          gap: 32,
          perView: 1,
          peek: {
            before: 0,
            after: 150,
          },
        },
        480: {
          gap: 20,
          perView: 1,
          peek: {
            before: 0,
            after: 70,
          },
        },
      },
    }).mount();
  }

  $posts.slick({
    arrows: false,
    speed: 1200,
    adaptiveHeight: false,
    dots: false,
    autoplay: false,
    fade: false,
    slidesToShow: 2,
  });

  $timelines.slick({
    arrows: false,
    speed: 1200,
    adaptiveHeight: false,
    dots: false,
    autoplay: false,
    fade: false,
    slidesToShow: 2,
    infinite: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  if ($activities.length) {
    var draggable = false;
    if ($activities.children().length > 2) {
      draggable = true;
    }

    $activities.slick({
      arrows: false,
      speed: 1200,
      adaptiveHeight: false,
      dots: false,
      autoplay: false,
      fade: false,
      slidesToShow: 4,
      infinite: false,
      centerMode: false,
      swipeToSlide: true,
      draggable: draggable,
      //touchThreshold: 100,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  $accomodation.slick({
    arrows: false,
    speed: 600,
    adaptiveHeight: false,
    dots: false,
    autoplay: false,
    fade: false,
    slidesToShow: 1,
    infinite: false,
    draggable: true,
  });

  $reviews.slick({
    arrows: false,
    speed: 600,
    adaptiveHeight: false,
    dots: false,
    autoplay: true,
    fade: false,
    slidesToShow: 2,
    infinite: false,
    draggable: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  if ($(window).width() < 960) {
    $reviews_mobile.slick({
      arrows: false,
      speed: 600,
      adaptiveHeight: false,
      dots: false,
      autoplay: true,
      fade: false,
      slidesToShow: 1,
      infinite: true,
      draggable: true,
    });
  }

  let variableWidth = false;
  if ($instagram.children().length > 4) {
    variableWidth = true;
    $instagram.addClass("variable-width");
  }

  $instagram.slick({
    arrows: false,
    speed: 1200,
    adaptiveHeight: true,
    dots: false,
    autoplay: true,
    fade: false,
    slidesToShow: 4,
    infinite: true,
    draggable: variableWidth,
    variableWidth: variableWidth,
    touchThreshold: 100,
    swipeToSlide: true,
  });

  if ($(".instagram-splider").length) {
    new Splide(".instagram-splider", {
      type: "loop",
      clones: 8,
      autoHeight: true,
      autoWidth: true,
      gap: "40px",
      pagination: false,
      // drag: "free",
      speed: 1000,
      // flickPower: 400,
      // padding: { left: 0, right: 200 },
    }).mount();
  }

  let nsc_ltrVariableWidth = false;
  if ($ns_collective_ltr.children().length > 4) {
    nsc_ltrVariableWidth = true;
    $ns_collective_ltr.addClass("variable-width");
  }
  $ns_collective_ltr.slick({
    arrows: false,
    speed: 1200,
    adaptiveHeight: true,
    dots: false,
    autoplay: true,
    fade: false,
    slidesToShow: 4,
    infinite: true,
    draggable: nsc_ltrVariableWidth,
    variableWidth: nsc_ltrVariableWidth,
    touchThreshold: 100,
    swipeToSlide: true,
  });

  ///

  let nsc_rtlVariableWidth = false;
  if ($ns_collective_rtl.children().length > 4) {
    nsc_rtlVariableWidth = true;
    $ns_collective_rtl.addClass("variable-width");
  }
  $ns_collective_rtl.slick({
    arrows: false,
    speed: 1200,
    adaptiveHeight: true,
    dots: false,
    autoplay: true,
    fade: false,
    slidesToShow: 4,
    infinite: true,
    draggable: nsc_ltrVariableWidth,
    variableWidth: nsc_ltrVariableWidth,
    touchThreshold: 100,
    swipeToSlide: true,
    rtl: true,
  });

  if ($courses_info_boxes_slider.length) {
    let draggable = false;
    if ($courses_info_boxes_slider.children().length > 2) {
      draggable = true;
    }

    $courses_info_boxes_slider.slick({
      arrows: false,
      infinite: false,
      speed: 1200,
      dots: false,
      slidesToShow: 2,
      draggable: draggable,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  $bar = $(".slider-progress .progress");
  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    isPause = false;
    tick = setInterval(interval, 30);
  }

  $(".slider").on("init", function (slick) {
    startProgressbar();
  });

  // progress bar will trigger next slide
  if ($(".hero-slider").find(".progress-box").length) {
    $slick.slick({
      arrows: false,
      speed: 1200,
      dots: true,
      fade: true,
    });
  } else {
    $slick.slick({
      arrows: false,
      speed: 1200,
      dots: true,
      fade: true,
      autoplay: true,
    });
  }

  function interval() {
    if (isPause === false) {
      percentTime += 1 / (time + 0.1);
      $bar.css({
        width: percentTime + "%",
      });
      if (percentTime >= 100) {
        $slick.slick("slickNext");
        startProgressbar();
      }
    }
  }

  function resetProgressbar() {
    $bar.css({
      width: 0 + "%",
    });
    clearTimeout(tick);
  }

  $(
    ".hero-slider .slick-next, .hero-slider .slick-prev, .hero-slider .progress-box .prev, .hero-slider .progress-box .next, .hero-slider .slick-dots button"
  ).click(function () {
    startProgressbar();
  });

  $bar1 = $(".section-courses .slider-progress .progress");
  function startProgressbar1() {
    resetProgressbar1();
    percentTime1 = 0;
    isPause1 = false;
    tick1 = setInterval(interval1, 30);
  }

  function interval1() {
    if (isPause1 === false) {
      percentTime1 += 1 / (time1 + 0.1);
      $bar1.css({
        width: percentTime1 + "%",
      });
      if (percentTime1 >= 100) {
        $courses.slick("slickNext");
        startProgressbar1();
      }
    }
  }

  function resetProgressbar1() {
    $bar1.css({
      width: 0 + "%",
    });
    clearTimeout(tick1);
  }

  startProgressbar1();

  $(".section-courses .courses-prev, .section-courses .courses-next").click(
    function () {
      startProgressbar1();
    }
  );

  $bar2 = $(".section-articles .slider-progress .progress");
  function startProgressbar2() {
    resetProgressbar2();
    percentTime2 = 0;
    isPause2 = false;
    tick2 = setInterval(interval2, 30);
  }

  function interval2() {
    if (isPause2 === false) {
      percentTime2 += 1 / (time + 0.1);
      $bar2.css({
        width: percentTime2 + "%",
      });
      if (percentTime2 >= 100) {
        $articles.slick("slickNext");
        startProgressbar2();
      }
    }
  }

  function resetProgressbar2() {
    $bar2.css({
      width: 0 + "%",
    });
    clearTimeout(tick2);
  }

  startProgressbar2();

  $(".section-articles .articles-prev, .section-articles .articles-next").click(
    function () {
      startProgressbar2();
    }
  );

  $bar10 = $(".section-photos .slider-progress .progress");
  function startProgressbar10() {
    resetProgressbar10();
    percentTime10 = 0;
    isPause10 = false;
    tick10 = setInterval(interval10, 30);
  }

  function interval10() {
    if (isPause10 === false) {
      // percentTime10 += 1 / (2000000 + 0.1);
      percentTime10 += 1 / (time + 0.1);
      $bar10.css({
        width: percentTime10 + "%",
      });
      if (percentTime10 >= 100) {
        $photos.slick("slickNext");
        $photos.on('setPosition', function (event, slick) {
          // slick.$slides.css('width', slick.$slideTrack.$slides.width() + 'px');
          largeSlideScroll();
          $photos.on('afterChange', function (event, slick, currentSlide) {
            const activeSlide = slick.$slides.eq(currentSlide);
            const activeCaption = activeSlide.find('.caption').data("caption");

            $('.active-caption').text(activeCaption);
          });
        });

        startProgressbar10();
      }
    }
  }

  function resetProgressbar10() {
    $bar10.css({
      width: 0 + "%",
    });
    clearTimeout(tick10);
  }

  startProgressbar10();

  $(".section-photos .photos-prev, .section-photos .photos-next").click(
    function () {
      startProgressbar10();
    }
  );

  function largeSlideScroll() {
    if (phototoggleval == 0) {
      $(".photos-slider .slick-list .slick-track .slick-active").css("width", photoSlideWidth);
      $(".photos-slider").removeClass("photo-small");
    }
    if (phototoggleval == 1) {
      $(".photos-slider .slick-list .slick-track .slick-active").css("width", "400px");
      $(".photos-slider").addClass("photo-small");
    }
  }
  $(document).ready(function () {
    phototoggleval = 0;
    photoSlideWidth = $(".photos-slider .slick-list .slick-track .slick-cloned").outerWidth();
  });
  $(document).on("click", ".inPhoto-large-icon", function () {
    if (phototoggleval == 0) {
      phototoggleval = 1;
      largeSlideScroll();

      $('.inPhoto-large-icon').css('opacity', 1);
      $('.inPhoto-small-icon').css('opacity', 0.4);
    }
  });

  $(document).on("click", ".inPhoto-small-icon", function () {
    if (phototoggleval == 1) {
      phototoggleval = 0;
      largeSlideScroll();
      $('.inPhoto-large-icon').css('opacity', 0.4);
      $('.inPhoto-small-icon').css('opacity', 1);
    }
  });



  $bar3 = $(".posts-gallery .slider-progress .progress");
  function startProgressbar3() {
    resetProgressbar3();
    percentTime3 = 0;
    isPause3 = false;
    tick3 = setInterval(interval3, 30);
  }

  function interval3() {
    if (isPause3 === false) {
      percentTime3 += 1 / (time + 0.1);
      $bar3.css({
        width: percentTime3 + "%",
      });
      if (percentTime3 >= 100) {
        $posts.slick("slickNext");
        startProgressbar3();
      }
    }
  }

  function resetProgressbar3() {
    $bar3.css({
      width: 0 + "%",
    });
    clearTimeout(tick3);
  }

  startProgressbar3();

  $(".posts-gallery .posts-prev, .posts-gallery .posts-next").click(
    function () {
      startProgressbar3();
    }
  );

  $bar4 = $(".timeline-slider .slider-progress .progress");
  function startProgressbar4() {
    resetProgressbar4();
    percentTime4 = 0;
    isPause4 = true;
    tick4 = setInterval(interval4, 30);
  }

  function interval4() {
    if (isPause4 === false) {
      percentTime4 += 1 / (time + 0.1);
      $bar4.css({
        width: percentTime4 + "%",
      });
      if (percentTime4 >= 100) {
        $timelines.slick("slickNext");
        startProgressbar4();
      }
    }
  }

  function resetProgressbar4() {
    $bar4.css({
      width: 0 + "%",
    });
    clearTimeout(tick4);
  }

  startProgressbar4();

  $bar5 = $("#accommodation .slider-progress .progress");

  if ($bar1 || $bar2 || $bar3 || $bar4 || $bar5 || $bar6 || $bar10) {
  } else {
    startProgressbar();
  }

  $("#timeline .posts-prev, #timeline .posts-next").click(function () {
    startProgressbar4();
  });

  $("#timeline .timeline-prev").click(function () {
    $("#timeline .timeline-slider").slick("slickPrev");
  });
  $("#timeline .timeline-next").click(function () {
    $("#timeline .timeline-slider").slick("slickNext");
  });
  $(".hero-slider .progress-box .prev").click(function () {
    $(".slider").slick("slickPrev");
  });
  $(".hero-slider .progress-box .next").click(function () {
    $(".slider").slick("slickNext");
  });
  $(".section-courses .courses-prev").click(function () {
    $(".section-courses .courses-slider").slick("slickPrev");
  });
  $(".section-courses .courses-next").click(function () {
    $(".section-courses .courses-slider").slick("slickNext");
  });
  $(".section-articles .articles-prev").click(function () {
    $(".section-articles .articles-slider").slick("slickPrev");
  });
  $(".section-articles .articles-next").click(function () {
    $(".section-articles .articles-slider").slick("slickNext");
  });

  $(".section-photos .photos-prev").click(function () {
    $(".section-photos .photos-slider").slick("slickPrev");
  });
  $(".section-photos .photos-next").click(function () {
    $(".section-photos .photos-slider").slick("slickNext");
  });



  $(".posts-gallery .posts-prev").click(function () {
    $(".posts-gallery .post-slider").slick("slickPrev");
  });
  $(".posts-gallery .posts-next").click(function () {
    $(".posts-gallery .post-slider").slick("slickNext");
  });
  $("body").on("click", ".more-prev", function () {
    $(".more-slider").slick("slickPrev");
  });
  $("body").on("click", ".more-next", function () {
    $(".more-slider").slick("slickNext");
  });
  $("body").on("click", ".more-prev", function () {
    $(".destinations-slider").slick("slickPrev");
  });
  $("body").on("click", ".more-next", function () {
    $(".destinations-slider").slick("slickNext");
  });
  $("body").on("click", ".series-prev", function () {
    $(".series-slider").slick("slickPrev");
  });
  $("body").on("click", ".series-next", function () {
    $(".series-slider").slick("slickNext");
  });

  $(".full-width-video-slider .video-prev").click(function () {
    $(".full-width-video-slider .video_slider").slick("slickPrev");
  });
  $(".full-width-video-slider .video-next").click(function () {
    $(".full-width-video-slider .video_slider").slick("slickNext");
  });


  function slickPhotosCarousel() {
    $photos.slick({
      arrows: false,
      speed: 600,
      adaptiveHeight: false,
      dots: false,
      fade: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      draggable: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  function destroyPhotosCarousel() {
    if ($photos.hasClass('slick-initialized')) {
      $photos.slick('destroy');
    }
  }
  $('.filter-btn').on('click', function () {
    var filter = $(this).data('filter');
    $('.filter-btn').removeClass('active');
    $(this).addClass('active');

    destroyPhotosCarousel();
    $('.photos-slider').empty();


    if (filter === '*') {
      var filterClass = "slide_data";
    } else {
      var filterClass = "slide_data" + filter;
    }
    var slide_data = $(".slide_data").map(function () {
      if ($(this).hasClass(filterClass)) {
        return $(this).html();
      }
    }).get().join("");

    $('.photos-slider').append(slide_data);
    slickPhotosCarousel();
  });

}
